import { ThemeConfig } from './types'
import { typography, breakpoints, components } from './base.theme'

export const defaultTheme: ThemeConfig = {
  id: 'default',
  name: 'Admin',
  description: 'Admin portal theme',
  preview: {
    primaryColor: '#8B1538',
    secondaryColor: '#424242',
  },
  light: {
    palette: {
      mode: 'light',
      primary: {
        main: '#8B1538',
        light: '#B84363',
        dark: '#5C0E25',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#424242',
        light: '#6d6d6d',
        dark: '#1b1b1b',
        contrastText: '#ffffff',
      },
      background: {
        default: '#f5f5f5',
        paper: '#ffffff',
      },
    },
    typography,
    breakpoints,
    components,
  },
  dark: {
    palette: {
      mode: 'dark',
      primary: {
        main: '#B84363',
        light: '#D4728C',
        dark: '#8B1538',
        contrastText: '#ffffff',
      },
      secondary: {
        main: '#616161',
        light: '#8e8e8e',
        dark: '#373737',
        contrastText: '#ffffff',
      },
      background: {
        default: '#121212',
        paper: '#1e1e1e',
      },
    },
    typography,
    breakpoints,
    components,
  },
}
